import React from "react";
import { useLanguageContext } from "../Context/LanguageContext";
import Spinner from "./Spinner/Spinner";

export default function LangauageVerifier({ children }) {
  const { localization } = useLanguageContext();

  return localization ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <Spinner />
  );
}
